export class User {
  token?: string;
  user_id: bigint;
  name: string;
  username: string;
  role: string;
  lang: string;
  company: string;
  company_email: string;
  company_phone: string;
  dashboards: string;
  delivery: string;
  stock: string;
  email: string;
  phone: string;
  password: string;
  enviroment: string;
  permissions: string;
  group_id: number;
}